import config from "./config";

const directory = config.typinggame.directory;
const typingGame = [
    {
        category: "FE_1-1",
        link: `${config.flashUrl}/${directory}/FE_1-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_1-1 and 1-2",
        link: `${config.flashUrl}/${directory}/FE_1-1 and 1-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_1-2",
        link: `${config.flashUrl}/${directory}/FE_1-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_1to5",
        link: `${config.flashUrl}/${directory}/FE_1to5`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_1to12",
        link: `${config.flashUrl}/${directory}/FE_1to12`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_2-1",
        link: `${config.flashUrl}/${directory}/FE_2-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_2-1 and 2-2",
        link: `${config.flashUrl}/${directory}/FE_2-1 and 2-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_2-2",
        link: `${config.flashUrl}/${directory}/FE_2-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_3_all",
        link: `${config.flashUrl}/${directory}/FE_3_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_3-1",
        link: `${config.flashUrl}/${directory}/FE_3-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_3-2",
        link: `${config.flashUrl}/${directory}/FE_3-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_3-3",
        link: `${config.flashUrl}/${directory}/FE_3-3`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_4_all",
        link: `${config.flashUrl}/${directory}/FE_4_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_4-1",
        link: `${config.flashUrl}/${directory}/FE_4-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_4-2",
        link: `${config.flashUrl}/${directory}/FE_4-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_4-3",
        link: `${config.flashUrl}/${directory}/FE_4-3`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_5_all",
        link: `${config.flashUrl}/${directory}/FE_5_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_5-1",
        link: `${config.flashUrl}/${directory}/FE_5-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_5-2",
        link: `${config.flashUrl}/${directory}/FE_5-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_5-3",
        link: `${config.flashUrl}/${directory}/FE_5-3`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_6_all",
        link: `${config.flashUrl}/${directory}/FE_6_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_6-1",
        link: `${config.flashUrl}/${directory}/FE_6-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_6-2",
        link: `${config.flashUrl}/${directory}/FE_6-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_6to9",
        link: `${config.flashUrl}/${directory}/FE_6to9`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_7_all",
        link: `${config.flashUrl}/${directory}/FE_7_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_7-1",
        link: `${config.flashUrl}/${directory}/FE_7-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_7-2",
        link: `${config.flashUrl}/${directory}/FE_7-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_8_all",
        link: `${config.flashUrl}/${directory}/FE_8_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_8-1",
        link: `${config.flashUrl}/${directory}/FE_8-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_8-2",
        link: `${config.flashUrl}/${directory}/FE_8-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_9_all",
        link: `${config.flashUrl}/${directory}/FE_9_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_9-1",
        link: `${config.flashUrl}/${directory}/FE_9-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_9-2",
        link: `${config.flashUrl}/${directory}/FE_9-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_10_all",
        link: `${config.flashUrl}/${directory}/FE_10_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_10-1",
        link: `${config.flashUrl}/${directory}/FE_10-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_10-2",
        link: `${config.flashUrl}/${directory}/FE_10-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_10-3",
        link: `${config.flashUrl}/${directory}/FE_10-3`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_10to12",
        link: `${config.flashUrl}/${directory}/FE_10to12`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_11_all",
        link: `${config.flashUrl}/${directory}/FE_11_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_11-1",
        link: `${config.flashUrl}/${directory}/FE_11-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_11-2",
        link: `${config.flashUrl}/${directory}/FE_11-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_12_all",
        link: `${config.flashUrl}/${directory}/FE_12_all`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_12-1",
        link: `${config.flashUrl}/${directory}/FE_12-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "FE_12-2",
        link: `${config.flashUrl}/${directory}/FE_12-2`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "Number",
        link: `${config.flashUrl}/${directory}/Number`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "Rugang-1",
        link: `${config.flashUrl}/${directory}/Rugang-1`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "tsdx_01",
        link: `${config.flashUrl}/${directory}/tsdx_01`,
        target: true
    },
    {
        category: "tsdx_02",
        link: `${config.flashUrl}/${directory}/tsdx_02`,
        target: true
    },
    {
        category: "tsdx_03",
        link: `${config.flashUrl}/${directory}/tsdx_03`,
        target: true
    },
    {
        category: "tsdx_04",
        link: `${config.flashUrl}/${directory}/tsdx_04`,
        target: true
    },
    {
        category: "tsdx_05",
        link: `${config.flashUrl}/${directory}/tsdx_05`,
        target: true
    },
    {
        category: "tsdx_06",
        link: `${config.flashUrl}/${directory}/tsdx_06`,
        target: true
    },
    {
        category: "tsdx_07",
        link: `${config.flashUrl}/${directory}/tsdx_07`,
        target: true
    },
    {
        category: "tsdx_08",
        link: `${config.flashUrl}/${directory}/tsdx_08`,
        target: true
    },
    {
        category: "tsdx_09",
        link: `${config.flashUrl}/${directory}/tsdx_09`,
        target: true
    },
    {
        category: "tsdx_10",
        link: `${config.flashUrl}/${directory}/tsdx_10`,
        target: true
    },
    {
        category: "tsdx_11",
        link: `${config.flashUrl}/${directory}/tsdx_11`,
        target: true
    },
    {
        category: "tsdx_12",
        link: `${config.flashUrl}/${directory}/tsdx_12`,
        target: true
    },
    {
        category: "tsdx_13",
        link: `${config.flashUrl}/${directory}/tsdx_13`,
        target: true
    },
    {
        category: "tsdx_14",
        link: `${config.flashUrl}/${directory}/tsdx_14`,
        target: true
    },
    {
        category: "tsdx_15",
        link: `${config.flashUrl}/${directory}/tsdx_15`,
        target: true
    },
    {
        category: "tsdx_16",
        link: `${config.flashUrl}/${directory}/tsdx_16`,
        target: true
    },
    {
        category: "tsdx_17",
        link: `${config.flashUrl}/${directory}/tsdx_17`,
        target: true
    },
    {
        category: "tsdx_18",
        link: `${config.flashUrl}/${directory}/tsdx_18`,
        target: true
    },
    {
        category: "tsdx_19",
        link: `${config.flashUrl}/${directory}/tsdx_19`,
        target: true
    },
    {
        category: "tsdx_20",
        link: `${config.flashUrl}/${directory}/tsdx_20`,
        target: true
    }
];

export default typingGame;
